/**
 * @fileoverview Resolver hook for legal documents.
 *
 * Pure-function lookup against the static registry — no network, no
 * React state. The hook exists so consumer components have a stable
 * API: `useLegalDocument({ appKey, documentKey })` returns
 * `{ document, error }` and re-renders only when the inputs change.
 *
 * @module @puffin-core/legal-content/hooks/useLegalDocument
 */

import { useMemo } from 'react';
import { getLegalDocument } from '../registry/index.js';

/**
 * @param {{ appKey: string, documentKey: string }} args
 * @returns {{
 *   document: import('../registry/types.js').LegalDocument | null,
 *   error: Error | null,
 * }}
 */
export function useLegalDocument({ appKey, documentKey } = {}) {
  return useMemo(() => getLegalDocument(appKey, documentKey), [appKey, documentKey]);
}
